import { RouteObject } from 'react-router-dom';
import Hub from '.';
import TrainingHub from './TrainingHub';
import ProtectedHubRoute from './TrainingHub/ProtectedHubRoute';
import Settings from './Settings';
import CheckoutCallback from '../shared/navigation/CheckoutCallback';
import HubOrderConfirmation from '../shared/components/Cart/HubOrderConfirmation';

const routes: RouteObject[] = [
  {
    path: '/hub',
    element: <Hub />,
    children: [
      {
        path: ':accountId',
        element: (
          <ProtectedHubRoute
            pageName="Partner Platform"
            render={() => <TrainingHub />}
          />
        ),
      },
      {
        path: ':accountId/training-hub',
        element: (
          <ProtectedHubRoute
            pageName="Partner Platform"
            render={() => <TrainingHub />}
          />
        ),
      },
      {
        path: ':accountId/settings',
        element: (
          <ProtectedHubRoute pageName="Settings" render={() => <Settings />} />
        ),
      },
      {
        path: ':accountId/checkout-callback',
        element: (
          <ProtectedHubRoute pageName="" render={() => <CheckoutCallback />} />
        ),
      },
      {
        path: ':accountId/confirmation/:orderId',
        element: (
          <ProtectedHubRoute
            pageName=""
            render={() => <HubOrderConfirmation />}
          />
        ),
      },
    ],
  },
];

export default routes;
